var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.$route.name === 'manual' ? 'QuestionIndex' : 'QuestionForm',{tag:"component",attrs:{"product":_vm.product}})
}
var staticRenderFns = []

export { render, staticRenderFns }